import {
  feSidebarAppointmentClear,
  feSidebarClose,
  feSidebarDetourDepart,
  feSidebarDetourReturn,
  feSidebarDim,
  feSidebarOpen,
} from 'actions/ui.actions';
import SP from 'constants/ui/sidePanel.const';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isNotEnumVal from 'utils/predicates/enum/isNotEnumVal.util';

const L = logger('generalSidebarReducer');

const reduceDetourDepart = (state) => ({ ...state, open: false, detour: true });
const reduceDetourReturn = (state) => ({ ...state, open: true, detour: false });

const reduceSidebarClose = (state) => ({ ...state, open: false, dim: false, panel: null });
const reduceSidebarDim = (state) => ({ ...state, open: true, dim: true });

const reduceSidebarOpen = (state, action) => {
  const FTAG = `${feSidebarOpen.AT.name}()`;

  const panel = action.data?.panel;
  const isInvalidPanel = isNotEnumVal(SP, panel);

  if (isInvalidPanel) {
    L.warn(FTAG, 'Invalid panel:', panel);
    return state;
  }

  return { ...state, open: true, dim: false, panel };
};

const reduceClear = (state, action) => (action?.data?.full ? {} : state ?? {});

const MAP = Object.freeze({
  [feSidebarDetourDepart.AT.name]: reduceDetourDepart,
  [feSidebarDetourReturn.AT.name]: reduceDetourReturn,

  [feSidebarClose.AT.name]: reduceSidebarClose,
  [feSidebarDim.AT.name]: reduceSidebarDim,
  [feSidebarOpen.AT.name]: reduceSidebarOpen,

  [feSidebarAppointmentClear.AT.name]: reduceClear,
});

const generalSidebarReducer = (state, action) =>
  (MAP[action && action.type] || alwaysSame)(state || {}, asObject(action));

// noinspection JSUnusedGlobalSymbols
export default generalSidebarReducer;
